module.exports = __webpack_public_path__ + "Egencia_ico.png?fccf35f879a6fe3b0ab306652fad42a2";